<template>
  <sessions-list-wrapper
    v-bind:key="loading"
    v-bind:sessions_list="sessionsAnimated"
    title="Sessions terminées"
    no_result="Vous n'avez aucune session terminée."
    has_positionnement_modal
    is_sessions_terminees
    v-bind:current_space="'stagiaire'"
    v-on:fetch-sessions="fetchSessions"
    v-bind:loading="loading"
    v-bind:active_space="activeSpaceId" />
</template>
<script>
  import sessionsListWrapper from '../utils/sessions-list-wrapper.vue';
  import { API } from '@/http-common';

  export default {
    components: { sessionsListWrapper },
    props: ['props'],
    data: () => ({
      loading: false,
      sessionsAnimated: null
    }),
    computed: {
      activeSpaceId() {
        return this.$route.params.space_id;
      },
      stagiaire_famille_context() {
        return this.activeSpaceId === 'stagiaire'
          ? 'familleStage'
          : 'familleStageCAC';
      }
    },
    created() {
      this.fetchSessions();
    },
    methods: {
      async fetchSessions() {
        this.loading = true;
        const response = await API.get(
          'participant/sessions-terminees',
          this.$header_skip_redirection
        );

        this.sessionsAnimated = response.data
          ? response.data.filter((s) => s[this.stagiaire_famille_context])
          : [];
        this.loading = false;
      }
    }
  };
</script>
